export default {
    fleetAdmins: 'fleetAdmins',
    users: 'users',
    localAdmins: 'localAdmins',
    fleetManagers: 'fleetManagers'
}